import { CONFIG } from './config.js';
import { getFontData } from './fonts/font-data.js';
import { PollHero } from './poll-hero-element.js';
import { initialize } from './initialize.js';
import { initializePollHeroHelpers } from './api/helpers.js';

initializePollHeroHelpers();

const script = document.currentScript;
const url = new URL(script.src);
const projectId = url.searchParams.get('project_id');
const programmPreview = url.searchParams.get('isPreview') || false;
const isStandAloneSurvey = url.searchParams.get('isStandAlone') || false;
// isStandAlone + isPreview: the standalone page is rendered as a preview –
// always visible, nothing stored, nothing sent to the backend
const isStandAlonePreview = Boolean(isStandAloneSurvey && programmPreview);
const surveyIdFromURL = new URLSearchParams(window.location.search).get('pollhero-id');

const styleElement = document.createElement('style');
styleElement.textContent = getFontData(CONFIG.cdnBaseUrl);
document.head.appendChild(styleElement);

function registerCustomElement() {
    if (!surveyIdFromURL && !customElements.get('poll-hero')) {
        customElements.define('poll-hero', PollHero);
    }
}

if (!programmPreview || isStandAlonePreview) {
    if (projectId) {
        // Tag managers (GTM, Tealium) may inject the script once per virtual
        // pageview; each copy is a separate IIFE, so dedup must live on window
        window.__POLLHERO_LOADED_PROJECTS__ = window.__POLLHERO_LOADED_PROJECTS__ || {};
        if (!window.__POLLHERO_LOADED_PROJECTS__[projectId]) {
            window.__POLLHERO_LOADED_PROJECTS__[projectId] = true;
            initialize(projectId, surveyIdFromURL, isStandAloneSurvey, registerCustomElement, { isStandAlonePreview });
        }
    }
} else {
    if (!customElements.get('poll-hero')) {
        customElements.define('poll-hero', PollHero);
    }
}
